import Top10 from './Top10'

export default Top10
